import type { ApiErrorCode } from "./errors";

/**
 * The error every typed API client throws.
 *
 * Kept in its own module, with no runtime imports, so a component that only
 * checks `err instanceof ApiClientError` does not pull the whole API contract
 * (126 endpoints and their zod schemas) into the page's bundle.
 */
export class ApiClientError extends Error {
  constructor(
    readonly status: number,
    readonly code: ApiErrorCode | "contract_mismatch" | "network_error" | "invalid_request",
    message: string,
    readonly details?: Record<string, unknown>
  ) {
    super(message);
  }
}
